/**
 * In-memory continuity for the email-code sign-in flow. Boot refreshes while
 * gated (focus reconciliation, retries, transient boot-prop gaps) can remount
 * the flow component; a user who left to read the code email must return to
 * the code-entry step, not the email form. Memory only — session credentials
 * and codes never touch this module, and nothing here persists to storage.
 */

export interface SignInCodeStepMemory {
  email: string;
  provider: string;
  expiresIn: number | null;
}

let codeStep: SignInCodeStepMemory | null = null;

export function rememberSignInCodeStep(step: SignInCodeStepMemory): void {
  codeStep = { ...step };
}

export function recallSignInCodeStep(): SignInCodeStepMemory | null {
  return codeStep === null ? null : { ...codeStep };
}

export function clearSignInCodeStep(): void {
  codeStep = null;
}
